import * as React from 'react';
import { noop } from 'lodash';
import { View } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { CardView, rem, Spacer } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { TAB_SCREEN_HEADER_HEIGHT } from 'navigators/styles';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import ProductTourIntroCard from 'features/pots/components/ProductTourIntroCard';
import SaveTabSelectorControllable from 'features/pots/components/SaveTabSelectorControllable';
const WalkthroughSaveTabItem = () => {
    const styles = useStyles(styleSet);
    const { top } = useSafeAreaInsets();
    const scrollX = useSharedValue(0);
    const selectorScrollViewRef = React.useRef(null);
    const { deviceWidth: width } = useAppFrameDimensions();
    return (<View pointerEvents="none">
      <View style={{ height: TAB_SCREEN_HEADER_HEIGHT + top }}/>
      <View style={styles.container}>
        <CardView noMargin style={styles.card}>
          <SaveTabSelectorControllable width={width} scrollX={scrollX} setSelection={noop} shouldSaveTabHeaderScroll={false} selectorScrollViewRef={selectorScrollViewRef}/>
          <Spacer h={20}/>
          <ProductTourIntroCard cardStyles={styles.cardStyles}/>
        </CardView>
      </View>
    </View>);
};
export default React.memo(WalkthroughSaveTabItem);
const styleSet = createStyleSheets((colors) => ({
    container: {
        paddingHorizontal: rem(12),
    },
    card: {
        paddingVertical: rem(8),
        paddingHorizontal: rem(4),
        backgroundColor: colors.background.dark,
    },
    cardStyles: {
        marginHorizontal: 0,
    },
}));
